import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from './../components/Footer';
import Button from './../components/ui/Button';
import image1 from '../assets/images/contactus/image-1.jpg';
import image2 from '../assets/images/contactus/image-2.jpg';
import image12 from'../assets/images/homepage/bottom.jpg';
import { Link } from 'react-router-dom';

const Contact = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/products/`)
      .then(res => res.json())
      .then(data => {
        console.log('Fetched products:', data);
        setProducts(data);
      })
      .catch(err => console.error('Error fetching products:', err));
  }, []);

  const handleProductChange = (e) => {
    const productId = e.target.value;
    setSelectedProduct(productId);
    
    if (productId) {
      const product = products.find(p => p.id === parseInt(productId));
      console.log('Selected product:', product);
      console.log('Subcategories:', product?.subcategories);
      setSubcategories(product?.subcategories || []);
    } else {
      setSubcategories([]);
    }
  };
  return (
    <div className="min-h-screen bg-cream">
      <Header />

      {/* Hero */}
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex flex-col items-center gap-12 lg:flex-row">
            <div className="flex-1">
              <img src={image1} alt="Contact" className="w-full h-[500px] object-cover rounded-3xl shadow-xl" />
            </div>
            <div className="flex-1 max-w-xl">
              <div className="mb-3 text-xs font-semibold tracking-wider uppercase text-primary">Get In Touch</div>
              <h1 className="mb-6 font-serif text-5xl font-bold text-text-primary">Connect With Us</h1>
              <p className="mb-8 text-lg text-text-primary">
                We’re in the process of launching our social media channels to share baking tips, product news and more. Stay tuned for our official handles on LinkedIn and Instagram – we’d love to connect with you there and be a part of your professional network.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="inquiry-section" className="py-16 bg-white lg:bg-cream">
        <div className="max-w-4xl px-6 mx-auto lg:px-8">
          <div className="mb-12 text-center">
            <div className="mb-3 text-xs font-semibold tracking-wider uppercase text-primary">Enquiry Form</div>
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">Send Us Your Enquiry</h2>
            <p className=" text-text-primary">Fill out the form below and our team will get back to you with the right solution.</p>
          </div>

          <div className= "p-8 bg-white lg:bg-cream rounded-3xl shadow-soft lg:p-12">
            <form className="space-y-6" action="https://formsubmit.co/contact@enessafoods.com" method="POST">
              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <label className="block mb-2 font-medium text-brown">First Name *</label>
                  <input name="firstName" type="text" className="w-full px-4 py-3 border-2 rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="Enter your first name" required />
                </div>
                <div>
                  <label className="block mb-2 font-medium text-brown">Last Name</label>
                  <input name="lastName" type="text" className="w-full px-4 py-3 border-2 rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="Enter your last name" required/>
                </div>
              </div>

              <div>
                <label className="block mb-2 font-medium text-brown">Company Name</label>
                <input name="company" type="text" className="w-full px-4 py-3 border-2 rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="Your company name" required/>
              </div>

              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <label className="block mb-2 font-medium text-brown">Email *</label>
                  <input name="email" type="email" className="w-full px-4 py-3 border-2 rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="your@email.com" required/>
                </div>
                <div>
                  <label className="block mb-2 font-medium text-brown">Phone</label>
                  <input name="phone" type="tel" className="w-full px-4 py-3 border-2 rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="+91" required/>
                </div>
              </div>

              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <label className="block mb-2 font-medium text-brown">Product Inquiry</label>
                  <select name="product" value={selectedProduct} onChange={handleProductChange} className="w-full px-4 py-3 bg-white border-2 cursor-pointer rounded-xl border-brown/10 focus:border-primary focus:outline-none text-text-primary" style={{fontFamily: 'Poppins, sans-serif', fontSize: '16px'}} required>
                    <option value="" style={{fontFamily: 'Poppins, sans-serif'}}>Select a product</option>
                    {products.map(product => (
                      <option key={product.id} value={product.id} style={{fontFamily: 'Poppins, sans-serif'}}>{product.title}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block mb-2 font-medium text-brown">Product Sub-category</label>
                  <select name="subcategory" className="w-full px-4 py-3 bg-white border-2 cursor-pointer rounded-xl border-brown/10 focus:border-primary focus:outline-none text-text-primary" style={{fontFamily: 'Poppins, sans-serif', fontSize: '16px'}} disabled={!selectedProduct}>
                    <option value="" style={{fontFamily: 'Poppins, sans-serif'}}>Select a sub-category</option>
                    {subcategories && subcategories.length > 0 ? (
                      subcategories.filter(sub => sub.is_active).map(subcategory => (
                        <option key={subcategory.id} value={subcategory.name} style={{fontFamily: 'Poppins, sans-serif'}}>{subcategory.name}</option>
                      ))
                    ) : selectedProduct ? (
                      <option disabled style={{fontFamily: 'Poppins, sans-serif'}}>No subcategories available</option>
                    ) : null}
                  </select>
                </div>
              </div>

              <div>
                <label className="block mb-2 font-medium text-brown">Message</label>
                <textarea name="message" rows="5" className="w-full px-4 py-3 border-2 resize-none rounded-xl border-brown/10 focus:border-primary focus:outline-none" placeholder="Tell us about your requirements..." required></textarea>
              </div>

              <div className="flex items-center gap-2">
                <input type="checkbox" id="terms" className="w-4 h-4 rounded text-primary border-brown/20 focus:ring-primary" required/>
                <label htmlFor="terms" className="text-sm text-brown-light">I accept the Terms & Conditions</label>
              </div>

              {/* <div className="g-recaptcha" data-sitekey="6Lf5YA4sAAAAANwJxaOi0JYx4Gd9aOsStgvmpdrS">google recaptcha</div> */}

              <button type="submit" className="w-full px-8 py-4 text-lg font-medium text-white transition-all rounded-full bg-primary hover:bg-primary-dark">
                Submit →
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">Get In Touch With Enessa Foods Today</h2>
            <p className=" text-text-primary">Connect via phone, email, or in person – we’re here to assist you with expert guidance and prompt support.</p>
          </div>
      

          <div className="grid gap-8 md:grid-cols-3">
            <div className="p-8 text-center bg-white lg:bg-cream rounded-3xl">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10">
                <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M36 0H4C1.794 0 0 1.794 0 4V28C0 30.206 1.794 32 4 32H36C38.206 32 40 30.206 40 28V4C40 1.794 38.206 0 36 0ZM36 4V5.022L20 17.468L4 5.024V4H36ZM4 28V10.088L18.772 21.578C19.1222 21.8531 19.5547 22.0026 20 22.0026C20.4453 22.0026 20.8778 21.8531 21.228 21.578L36 10.088L36.004 28H4Z" fill="#AE2220"/>
                </svg>
              </div>
              <h4 className="mb-3 text-xl font-bold text-text-primary">Email</h4>
              <p className="mb-2 text-sm text-brown-light">General Inquiries:</p>
              <a href="mailto:contact@enessafoods.com" className="font-medium text-primary">contact@enessafoods.com</a>
              <p className="mt-3 mb-2 text-sm text-brown-light">Operations/Orders:</p>
              <a href="mailto:operation@enessafoods.com" className="font-medium text-primary">operation@enessafoods.com</a>
            </div>

            <div className="p-8 text-center bg-white lg:bg-cream rounded-3xl">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M35.4147 24.5859C35.2291 24.4 35.0087 24.2525 34.7661 24.1519C34.5234 24.0513 34.2633 23.9995 34.0007 23.9995C33.738 23.9995 33.4779 24.0513 33.2353 24.1519C32.9927 24.2525 32.7722 24.4 32.5867 24.5859L29.3987 27.7739C27.9207 27.3339 25.1627 26.3339 23.4147 24.5859C21.6667 22.8379 20.6667 20.0799 20.2267 18.6019L23.4147 15.4139C23.6006 15.2283 23.748 15.0079 23.8487 14.7653C23.9493 14.5227 24.0011 14.2626 24.0011 13.9999C24.0011 13.7372 23.9493 13.4772 23.8487 13.2345C23.748 12.9919 23.6006 12.7715 23.4147 12.5859L15.4147 4.58591C15.2291 4.40002 15.0087 4.25255 14.7661 4.15193C14.5234 4.0513 14.2633 3.99951 14.0007 3.99951C13.738 3.99951 13.4779 4.0513 13.2353 4.15193C12.9927 4.25255 12.7722 4.40002 12.5867 4.58591L7.16267 10.0099C6.40267 10.7699 5.97467 11.8139 5.99067 12.8799C6.03667 15.7279 6.79067 25.6199 14.5867 33.4159C22.3827 41.2119 32.2747 41.9639 35.1247 42.0119H35.1807C36.2367 42.0119 37.2347 41.5959 37.9907 40.8399L43.4147 35.4159C43.6006 35.2303 43.748 35.0099 43.8487 34.7673C43.9493 34.5247 44.0011 34.2646 44.0011 34.0019C44.0011 33.7392 43.9493 33.4792 43.8487 33.2365C43.748 32.9939 43.6006 32.7735 43.4147 32.5879L35.4147 24.5859ZM35.1607 38.0099C32.6647 37.9679 24.1247 37.2979 17.4147 30.5859C10.6827 23.8539 10.0307 15.2839 9.99067 12.8379L14.0007 8.82791L19.1727 13.9999L16.5867 16.5859C16.3516 16.8208 16.1788 17.1106 16.0838 17.4291C15.9888 17.7475 15.9747 18.0846 16.0427 18.4099C16.0907 18.6399 17.2647 24.0939 20.5847 27.4139C23.9047 30.7339 29.3587 31.9079 29.5887 31.9559C29.9138 32.0258 30.2512 32.0128 30.57 31.9181C30.8887 31.8234 31.1785 31.65 31.4127 31.4139L34.0007 28.8279L39.1727 33.9999L35.1607 38.0099Z" fill="#AE2220"/>
                </svg>
              </div>
              <h4 className="mb-3 text-xl font-bold text-text-primary">Phone</h4>
              <p className="mb-2 text-sm text-brown-light">Phone 1:</p>
              <a href="tel:+919823107666" className="font-medium text-primary">+91 9823107666</a>
              <p className="mt-3 mb-2 text-sm text-brown-light">Phone 2:</p>
              <a href="tel:+919823108666" className="font-medium text-primary">+91 9823108666</a>
            </div>

            <div className="p-8 text-center bg-white lg:bg-cream rounded-3xl">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24.0001 28C28.4121 28 32.0001 24.412 32.0001 20C32.0001 15.588 28.4121 12 24.0001 12C19.5881 12 16.0001 15.588 16.0001 20C16.0001 24.412 19.5881 28 24.0001 28ZM24.0001 16C26.2061 16 28.0001 17.794 28.0001 20C28.0001 22.206 26.2061 24 24.0001 24C21.7941 24 20.0001 22.206 20.0001 20C20.0001 17.794 21.7941 16 24.0001 16Z" fill="#AE2220"/>
                  <path d="M22.8402 43.628C23.1787 43.8697 23.5842 43.9997 24.0002 43.9997C24.4161 43.9997 24.8217 43.8697 25.1602 43.628C25.7682 43.198 40.0582 32.88 40.0002 20C40.0002 11.178 32.8222 4 24.0002 4C15.1782 4 8.00018 11.178 8.00018 19.99C7.94218 32.88 22.2322 43.198 22.8402 43.628ZM24.0002 8C30.6182 8 36.0002 13.382 36.0002 20.01C36.0422 28.886 27.2242 36.856 24.0002 39.47C20.7782 36.854 11.9582 28.882 12.0002 20C12.0002 13.382 17.3822 8 24.0002 8Z" fill="#AE2220"/>
                </svg>
              </div>
              <h4 className="mb-3 text-xl font-bold text-text-primary">Office</h4>
              <p className="text-sm leading-relaxed text-brown-light">
                Office No. 204, M.M. Palace,<br/>
                Kondhwa Khurd, Pune,<br/>
                Maharashtra, India - 411048
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex items-center justify-center bg-gray-200 rounded-2xl h-96">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.3855286287976!2d73.88390787523545!3d18.46618818261694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2ebb116c68fbd%3A0x5e9d972f5715d2a!2sM%20M%20palace!5e0!3m2!1sen!2sin!4v1762848023598!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style={{border: 0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-2xl"
            ></iframe>
            {/* <p className="text-brown-light">Map will be embedded here</p> */}
          </div>
        </div>
      </section>

      {/* CTA */}
     <section className="py-24 bg-white lg:py-40 lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="bg-white rounded-[40px] p-12 lg:p-24 shadow-soft flex flex-col lg:flex-row-reverse items-center gap-16">
            <div className="flex-1">
              <img src={image12} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="mb-8 leading-tight font-heading text-heading-lg text-text-primary">
               Start a conversation about your baking needs!
              </h2>
              <p className="mb-10 leading-normal font-body text-body-lg text-text-primary">
                Call or email Enessa Foods today. Whether you want to request a product catalog, ask for a sample, or seek technical advice, we are here to help you bake the future.
              </p>
              <div className="flex flex-wrap justify-center gap-6 lg:justify-start">
                <Link to="/contact"><Button variant="primary" size="large">Contact Us</Button></Link>
                <Link to="#inquiry-section"><Button variant="secondary" size="large">Enquiry Form</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default Contact;